"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var options_1 = require("./options");
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
exports.isObject = isObject;
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
exports.isPrimitive = isPrimitive;
var $style; // yes, I use global variables and have no shame
function replaceClasses(vm, data) {
    $style = vm.$style;
    if (data.staticClass)
        data.staticClass = processString(data.staticClass);
    if (data.class)
        data.class = processClass(data.class);
}
exports.replaceClasses = replaceClasses;
function processClass(value) {
    if (Array.isArray(value))
        return processArray(value);
    if (isObject(value))
        return processObject(value);
    if (typeof value === 'string')
        return processString(value);
    return value;
}
function processArray(value) {
    return value.map(processClass);
}
function processString(value) {
    return value.replace(/\S+/g, function (cls) { return $style[cls] || options_1.default.global[cls] || cls; });
}
function processObject(value) {
    var obj = {};
    for (var key in value)
        obj[processString(key)] = value[key];
    return obj;
}
//# sourceMappingURL=class.js.map